<template lang="pug">
.campaign-participants(v-loading="loading")
  template(v-if="campaignUser.market")
    title-bar {{ $t('市场部') }}
    campaign-participants-input(
      :data="campaignUser.market"
      :canEdit="campaignUser.market.can_edit"
      @changeLeader="changeLeader"
      @changeCopyTo="changeCopyTo"
      @confirm="onConfirm"
      :group="'market'"
      @addCopyTo="addCopyTo"
      @deleteCopyTo="deleteCopyTo"
      @changeMail="changeMail"
    )
  template(v-if="campaignUser.purchase")
    title-bar {{ $t('采购部') }}
    campaign-participants-input(
      :canEdit="campaignUser.purchase.can_edit"
      :data="campaignUser.purchase"
      @changeLeader="changeLeader"
      @changeCopyTo="changeCopyTo"
      @confirm="onConfirm"
      :group="'purchase'"
      @addCopyTo="addCopyTo"
      @deleteCopyTo="deleteCopyTo"
      @changeMail="changeMail"
      @changeSOW="changeSOW"
      @confirmSOW="onConfirmSOW"
    )
  template(v-if="campaignUser.ec")
    title-bar {{ $t('EC') }}
    campaign-participants-input(
      :canEdit="campaignUser.ec.can_edit"
      :data="campaignUser.ec"
      @changeLeader="changeLeader"
      @changeCopyTo="changeCopyTo"
      @confirm="onConfirm"
      :group="'ec'"
      @addCopyTo="addCopyTo"
      @deleteCopyTo="deleteCopyTo"
      @changeMail="changeMail"
    )
  template(v-if="campaignUser.it")
    title-bar {{ $t('ITBP') }}
    campaign-participants-input(
      :canEdit="campaignUser.it.can_edit"
      :data="campaignUser.it"
      @changeLeader="changeLeader"
      @changeCopyTo="changeCopyTo"
      @confirm="onConfirm"
      :group="'it'"
      @addCopyTo="addCopyTo"
      @deleteCopyTo="deleteCopyTo"
      @changeMail="changeMail"
    )
  template(v-if="campaignUser.DOT")
    title-bar {{ $t('DOT') }}
    campaign-participants-input(
      :canEdit="campaignUser.DOT.can_edit"
      :data="campaignUser.DOT"
      @changeLeader="changeLeader"
      @changeCopyTo="changeCopyTo"
      @confirm="onConfirm"
      :group="'DOT'"
      @addCopyTo="addCopyTo"
      @deleteCopyTo="deleteCopyTo"
      @changeMail="changeMail"
    )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import CampaignParticipantsInput from './CampaignParticipantsInput'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import { pickBy } from 'lodash'

export default {
  components: {
    TitleBar,
    CampaignParticipantsInput
  },
  data () {
    return {
      market: {},
      purchase: {},
      it: {},
      campaignUser: {},
      loading: true
    }
  },
  mounted () {
    this.getCampaignUser()
  },
  methods: {
    getCampaignUser () {
      axios.get('/management/campaign/getCampaignUser', {
        params: {
          campaign_id: this.$store.state.campaign.id
        }
      })
        .then(res => {
          this.loading = false
          this.campaignUser = res
        })
    },
    changeLeader (index, v, group) {
      this.campaignUser[group].leader[index].user_id = v.user_id
      this.campaignUser[group].leader[index].mail = v.mail
    },
    changeCopyTo (index, v, group) {
      this.campaignUser[group].cc[index].user_id = v.user_id
      this.campaignUser[group].cc[index].mail = v.mail
    },
    changeSOW (parentIndex, index, v) {
      this.campaignUser.purchase.sow[parentIndex].leader[index].user_id = v.user_id
      this.campaignUser.purchase.sow[parentIndex].leader[index].mail = v.mail
    },
    async onConfirm (group) {
      const leader = this.campaignUser[group].leader
      const cc = this.campaignUser[group].cc
      const parentLeader = this.campaignUser[group].parent_leader
      const params = {
        campaign_id: this.$store.state.campaign.id,
        campaign_user: leader.concat(cc, parentLeader).map(o => {
          const res = {
            user_id: o.user_id,
            user_type: o.user_type,
            is_deletable: o.is_deletable,
            is_visible: o.is_visible,
            audit_user_id: o.audit_user_id
          }
          return pickBy(res, v => { return v != null })
        })
      }
      try {
        await axios.post('/management/campaign/updateCampaignUser', format4backend(params))
        this.$message.success(this.$t('更新成功'))
        this.getCampaignUser()
      } catch (err) {
        this.$message.error(this.$t('更新失败'))
      }
    },
    async onConfirmSOW () {
      const params = {
        sub_final_scope_user: this.campaignUser.purchase.sow.map(o => {
          return {
            user_id: o.leader[0].user_id,
            user_type: o.leader[0].user_type,
            is_deletable: o.leader[0].is_deletable,
            is_visible: o.leader[0].is_visible,
            audit_user_id: o.leader[0].audit_user_id,
            sub_final_scope_id: o.leader[0].sub_final_scope_id
          }
        })
      }
      try {
        axios.post('/management/subfinal/v3/updateSubFinalScopeUser', format4backend(params))
      } catch (err) {
        this.$message.error(this.$t('更新失败'))
      }
    },
    addCopyTo (group) {
      const CC = {
        user_type: 2,
        user_id: null,
        is_deletable: 0,
        is_visible: 1,
        audit_user_id: null,
        mail: ''
      }
      this.campaignUser[group].cc.push(CC)
    },
    deleteCopyTo (index, group) {
      this.campaignUser[group].cc.splice(index, 1)
    },
    changeMail (index, value, type, group) {
      this.campaignUser[group][type][index].mail = value
    }
  }
}
</script>

<style lang="stylus">
.campaign-participants
  margin-top 48px
  .title-bar
    margin-bottom 0
</style>
